import React, { useState } from 'react';
import './exit.css';
import Button from '../../UI/Button/Button';
import { Navigate } from 'react-router-dom';

const ModalExit = ({ setIsModalActive }) => {
    const [navigate, setNavigate] = useState(false);
    const handleNoClick = () => {
        setIsModalActive(false);
    };
    const handleLogout = () => {
        localStorage.removeItem('access_token');
        document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        setNavigate(true);
    };

    if (navigate) {
        return <Navigate to="/" />;
    }

    return (
        <div className='ModalExit'>
            <p>Выход</p>
            <p>Вы действительно хотите выйти?</p>
            <div>
                <Button className={"exitButtonSelect"} text={"Да"} onClick={handleLogout} />
                <Button className={"exitButtonSelect"} text={"Нет"} onClick={handleNoClick}/>
            </div>
        </div>
    );
};

export default ModalExit;
